import clsx from "clsx";
import React, { useEffect, useState } from 'react';
import { addBackground } from "../../common/utils";

import styles from './styles.module.scss';
import Team from "./Team";
import { ContentfulPicture } from "../../common/interfaces";
import {ContactPanel} from "../../common/components";

const People = () => {
    const [peopleContext, setPeopleContext] = useState<any>({});

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/contentful/pages/people`)
            .then(response => response.json())
            .then(result => {
                setPeopleContext(result);
            })
            .catch((err) => console.error(err));
    }, []);

    const headData = peopleContext['Paragraph > Exceptional people make all the difference'];
    const backgroundPictures: ContentfulPicture[] = headData ? headData.pictures : [];

    const desktopBackground = backgroundPictures.find(({ title }) => title.includes('Desktop'))?.file || '';
    const mobileBackground = backgroundPictures.find(({ title }) => title.includes('Mobile'))?.file || '';

    return (
        <div>
            <section>
                <div className={clsx("row", styles.title)} style={addBackground(desktopBackground, mobileBackground)}>
                    <div className="col-lg-8 offset-lg-2">
                        <h1>
                            {headData?.headline}
                        </h1>
                    </div>
                </div>
                <div className={clsx("row", styles.topText)}>
                    <div className={`col-lg-8 offset-lg-2 ${styles.paragraphContainer}`}>
                        <p className={styles.titleText}>
                        {headData?.paragraph}
                        </p>
                    </div>
                </div>
            </section>

            <Team context={peopleContext}/>
            <hr className={styles.lineBreak}/>

            {Object.keys(peopleContext).includes('Contact form > Want a winning partner?') && <ContactPanel/>}
        </div>
    )
}

export default People;
